import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getNeighborhoodInput = (searchCriteria: SearchCriteriaModel): string | null =>
  searchCriteria.regionId ? searchCriteria.regionId : null;
